import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const LikeEmoji = (props: IIconProps) => (
  <BaseIcon width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      transform="translate(1.37 1.172)"
      fill={EColors.MEDIUM_GREY}
      stroke={EColors.WHITE}
      strokeWidth="1.527"
      fillRule="evenodd"
    >
      <path d="M6.023 10.24c2.376-1.137 3.781-2.375 4.216-3.716.652-2.01 1.13-2.98 1.13-5.264 0-2.285 3.812-1.174 4.255 1.04.295 1.476.44 3.78.436 6.914h7.946c2.454 0 1.91 1.928 1.383 3.59-.528 1.662-2.241 6.826-2.917 8.466-.676 1.64-.995 2.14-3.356 2.14H7.488c-1.327-.045-1.99-1.032-1.99-2.963" />
      <rect y="8.416" width="5.497" height="17.02" rx="1.729" />
    </g>
  </BaseIcon>
)

export default LikeEmoji
